import React from 'react';

import { SidePage } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { MoveTo } from '../MoveTo';
import ManageGroupsList from './ManageGroupsList';

const ManageGroupsSidepage = ({
  onClose,
  loading,
  fetching,
  open,
  onAddGroup,
  presets,
  onMoveTo,
  presetKey,
}) => {
  const [childComponent, showChildComponent] = useChildComponent();

  const handleMoveTo = (selectedPresetsIds, onClose) => {
    const submit = async (group) => {
      await onMoveTo({
        groupId: group.groupId,
        presetIds: selectedPresetsIds,
      });
    };

    showChildComponent(MoveTo, {
      presetKey,
      onAddGroup,
      onMoveTo: (groupData) => {
        submit(groupData);
        onClose();
      },
    });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      open={open}
      width={700}
      fetching={fetching}
      loading={loading}
    >
      <SidePage.Title title={'Manage Groups'} />
      <SidePage.NewBody disableGutters={true} dense={true} scroll={false}>
        <ManageGroupsList
          presets={presets}
          onMoveTo={handleMoveTo}
          onAddGroup={onAddGroup}
        />
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default ManageGroupsSidepage;
